import { Inject, Injectable, InjectionToken } from '@angular/core'

export const APP_NAME = new InjectionToken('APP name')
export const MAP_CENTER = new InjectionToken('map center')

@Injectable()
export class CrossPlatformService {
    thisYear = new Date().getFullYear()
    resourceMap = {
        siteName: {
            tracmanager: 'TracManager',
            grameenphone: 'Grameenphone',
            indonesia: 'CloudHawk',
            accugps: 'accugps'
        },
        copyright: {
            tracmanager: `Copyright © ${this.thisYear} TracManager All rights reserved.`,
            grameenphone: `Copyright © ${this.thisYear} Eastcompeace All rights reserved.`,
            indonesia: `Copyright © ${this.thisYear} CJ Logistics All rights reserved.`,
            accugps: `Copyright © ${this.thisYear} Accugps All rights reserved.`,
            cloudhawk: `Copyright © ${this.thisYear} Spark Technology Labs Inc. All rights reserved.`
        },
        termsOfService: {
            tracmanager: {
                url: 'http://www.tracmanager.com/Terms.aspx'
            },
            grameenphone: {
                url: '/pages/terms-of-service/'
            },
            indonesia: {
                url: 'https://www.cjlogistics.com'
            },
            accugps: {
                url: 'http:/accugps.com/TOS'
            },
            cloudhawk: {
                url: 'http:/accugps.com/TOS'
            }
        },
        googleApiKey: {
            tracmanager: 'client=gme-tracmanager',
            indonesia: 'client=gme-tracmanager',
            accugps: 'key=AIzaSyCtOqsTMCNyzyLVvCN-_sxW8pFW2vHut94'
        },
        googleApiTestKey: {
            tracmanager: 'key=AIzaSyBDTxfgU-PW53fq3gJnSv_-EOpp5v5Erv8',
            accugps: 'key=AIzaSyBDTxfgU-PW53fq3gJnSv_-EOpp5v5Erv8',
            indonesia: 'key=AIzaSyBDTxfgU-PW53fq3gJnSv_-EOpp5v5Erv8'
        },
        addDeviceTips: {
            tracmanager: {
                tip1: 'Please register your TracManager tracker before using TracManager Tracking System',
                tip2: 'if you do not have one Please contact TracManager'
            },
            grameenphone: {
                tip1: 'S/N and Activation Code can be found on the package, warranty card and also at the backside of the device.',
                tip2: ''
            },
            indonesia: {
                tip1: 'Please register your CloudHawk tracker before using CloudHawk Tracking System',
                tip2: 'if you do not have one Please contact CloudHawk'
            },
            accugps: {
                tip1: 'Please register your accugps tracker before using accugps Tracking System',
                tip2: 'if you do not have one Please contact accugps'
            }
        }
    }

    constructor(@Inject(APP_NAME) private appName) {
    }

    get(key) {
        if (this.resourceMap[key]) {
            return this.resourceMap[key][this.appName]
        }
        console.warn('CrossPlatform', 'no resource found')
    }
}
